import { Routes } from '@angular/router';

import { adminGuard } from './core/admin-guard';
import { onboardingGuard } from './core/onboarding-guard';
import { shellChildren } from './shell/shell.routes';

export const routes: Routes = [
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/sign-in.page').then((m) => m.SignInPage),
  },
  {
    path: 'not-authorised',
    loadComponent: () => import('./pages/not-authorised.page').then((m) => m.NotAuthorisedPage),
  },
  {
    path: '',
    loadComponent: () => import('./shell/shell').then((m) => m.Shell),
    children: shellChildren,
    canActivate: [adminGuard],
    // adminGuard first: onboardingGuard's question ("have they seen the tour")
    // only makes sense once there is an active staff member to ask about, and
    // it declines to answer for anyone else.
    canActivateChild: [adminGuard, onboardingGuard],
  },
  { path: '**', redirectTo: 'dashboards' },
];
